let scrollPos = 0;
const scrollPosSticky = 91;
const scrollPosHidden = 350;
const body = document.querySelector('body');

function checkPosition() {
    const windowY = window.scrollY;

    if (windowY < scrollPosSticky) {
        body.classList.remove('is-sticky');
    } else {
        body.classList.add('is-sticky');
    }

    if (windowY < scrollPosHidden) {
        body.classList.remove('is-hidden');
    } else {
        body.classList.add('is-hidden');
    }

    if (windowY < scrollPos) {
        body.classList.remove('is-hidden');
    }

    scrollPos = windowY;
}

checkPosition();
window.addEventListener('scroll', checkPosition);
